import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import { Eye, X } from "lucide-react";
import LoadingSpinner from "../components/LoadingSpinner";

const WebhookLogs = () => {
  const { id } = useParams();
  const [logs, setLogs] = useState([]);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');

  useEffect(() => {
    const fetchWebhookLogs = async () => {
      setLoading(true);
      let response
      try {
        if(type=="payout"){
        const response = await axiosInstance.get(
          `/loan/loans/payout-webhook-logs/${id}`
        );
        setLogs(response.data.data);
      } 
      if(type=="mandate"){
        const response = await axiosInstance.get(
          `/payments/mandate-webhook/list?mandateId=${id}&limit=1000&page=1`
        );
        setLogs(response.data.data.mandateWebhookLogs);
      } 
      if(type=="payments"){
        const response = await axiosInstance.get(
          `/payments/mandate-webhook/list?paymentId=${id}&limit=1000&page=1`
        );
        setLogs(response.data.data.mandateWebhookLogs);
      } 
      } catch (error) {
        console.error("Error fetching webhook logs:", error);
      }
      setLoading(false);
    };
    if(id && type){
    fetchWebhookLogs();
    }
  }, [id]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Webhook Logs</h1>
      {loading ? (
      <LoadingSpinner />
      ) : (
        <div className="overflow-scroll">
        {type=="payout"?
        <table className="w-full border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">ID</th>
              <th className="border p-2">Loan ID</th>
              <th className="border p-2">Transfer ID</th>
              <th className="border p-2">Event Type</th>
              <th className="border p-2">Payment Status</th>
              <th className="border p-2">Amount</th>
              <th className="border p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border">
                <td className="border p-2">{log.id}</td>
                <td className="border p-2">{log.loanId}</td>
                <td className="border p-2">{log.transferId}</td>
                <td className="border p-2">{log.eventType}</td>
                <td className="border p-2">{log.paymentStatus}</td>
                <td className="border p-2">{log.paymentAmount}</td>
                <td className="border p-2 text-center">
                  <button
                    className="text-blue-500 hover:text-blue-700"
                    onClick={() => setSelectedLog(log.webhookJson)}
                  >
                    <Eye size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          
        </table>:
        <table className="w-full border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">ID</th>
              <th className="border p-2">Cf Order Id</th>
              <th className="border p-2">Cf Subscription Id</th>

              <th className="border p-2">Payment ID</th>
              <th className="border p-2">Event Type</th>
              <th className="border p-2">Subscription Id </th>

              <th className="border p-2">Payment Status</th>
              <th className="border p-2">Amount</th>
              <th className="border p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border">
                <td className="border p-2">{log.id}</td>
                <td className="border p-2">{log.cfOrderId}</td>
                <td className="border p-2">{log.cfSubscriptionId}</td>
                <td className="border p-2">{log.cfPaymentId}</td>

                <td className="border p-2">{log.eventType}</td>
                <td className="border p-2">{log.subscriptionId}</td>

                <td className="border p-2">{log.paymentStatus}</td>
                <td className="border p-2">{log.paymentAmount}</td>
                <td className="border p-2 text-center">
                  <button
                    className="text-blue-500 hover:text-blue-700"
                    onClick={() => setSelectedLog(log.webhookJson)}
                  >
                    <Eye size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          
        </table>
        
        }
        </div>
      )}

      {selectedLog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-4 rounded-lg w-1/2 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-2">
              <h2 className="text-xl font-semibold">Webhook JSON</h2>
              <button onClick={() => setSelectedLog(null)}>
                <X size={20} className="text-gray-600 hover:text-gray-800" />
              </button>
            </div>
            <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">
              {JSON.stringify(selectedLog, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

export default WebhookLogs;